import React from 'react'
import Routes from '../router/router'
import { withRouter } from 'react-router-dom'
import routes from '../router/routes'
import TemplateWrapper from '../pages/templateWrapper'

class AppNavigator extends React.Component {
    componentDidMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            if (location.pathname === routes.main.path && action !== 'PUSH') {
                this.props.history.push(routes.main.path)
            }
        })
    }

    componentWillUnmount() {
        this.unlisten()
    }

    render() {
        return (
            <section>
                <TemplateWrapper>{Routes()}</TemplateWrapper>
            </section>
        )
    }
}

export default withRouter(AppNavigator)
